import { defineAsyncComponent } from 'vue';

export { TimeEntryActions } from './components/TimeEntryActions';
export {
	TimeEntryDone,
	TimeEntryDoneSkeleton,
} from './components/TimeEntryDone';
export * from './types';

export const timeEntryMicroFrontends = {
	InvoiceAllocationDropdown: defineAsyncComponent(
		() =>
			import('./components/InvoiceAllocation/InvoiceAllocationDropdown.vue')
	),
	InvoiceAllocationDropdownModal: defineAsyncComponent(
		() =>
			import('./components/InvoiceAllocation/InvoiceAllocationDropdownModal.vue')
	),
};
